import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class APIKey extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'APIKey'
  // Define default properties here
  static instanceDefaults() {
    return {
      apiKey: ''
    }
  }
}
const servicePath = 'api-keys'
const servicePlugin = makeServicePlugin({
  Model: APIKey,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
